import React from "react";

import { Box } from "@mui/material";

export const TABLE_HEIGHT = 720;
export const ROW_MIN_HEIGHT = "44px";

export const COLUMN_WIDTH = {
  name: 180,
  location: 200,
  sourceName: 160,
  id: 260,
};

export function CellRow({ children }: { children: React.ReactNode }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      minHeight={ROW_MIN_HEIGHT}
    >
      {children}
    </Box>
  );
}

// Shared header cell formatting, applied via the DataGrid's sx prop.
export const dataGridSx = {
  // Removes the default cell border on click
  "& .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  "& .MuiDataGrid-cell": {
    fontSize: "0.8125rem",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
    fontSize: "0.8125rem",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "action.selected",
  },
  // Custom renderHeader content (e.g. Signal's help icon) otherwise competes
  // for space with the sort icon in the same flex row, causing them to
  // visually overlap on hover at narrower widths.
  "& .MuiDataGrid-columnHeaderTitleContainerContent": {
    flexGrow: 1,
  },
  "& .MuiDataGrid-sortIcon": {
    fontSize: "1rem",
  },
};
